import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import GrowthWheelPagination from '../../components/GrowthWheelPagination/GrowthWheelPagination'
import { getPageTransitionClass } from '../../utils/growth-wheel-utils'
import { useGrowthWheelPagination } from '../../hooks/useGrowthWheelPagination'
import '../../css/growthWheel.scss'
import CompetencyAssessmentTitleCard from '../../components/GrowthWheelComponents/CompetencyAssessmentTitleCard'
import CompetencyAssessmentContent from '../../components/GrowthWheelComponents/CompetencyAssessmentContent'
import { CompetencyWithEvaluation } from '../../types/GrowthWheel'
import { useContentTransition } from '../../hooks/useContentTransition'
import BackButton from '../../components/GrowthWheelComponents/BackButton'


interface GrowthWheelCompetencyAssessmentProps {
  currentCompetency: CompetencyWithEvaluation
  competencyList: CompetencyWithEvaluation[]
  handleClickCompetencyChange: (competency: CompetencyWithEvaluation | null) => void
}

const GrowthWheelCompetencyAssessment = ({ currentCompetency, handleClickCompetencyChange, competencyList }: GrowthWheelCompetencyAssessmentProps) => {
  const { currentIndex, handlePrevious, handleNext } = useGrowthWheelPagination(
    competencyList,
    currentCompetency,
    handleClickCompetencyChange
  )
  const { isTransitioning, transitionDirection } = useContentTransition(currentIndex)

  return (
    <div className="container mb-5 gw-competency-area-view">
      <BackButton onClick={() => handleClickCompetencyChange(null)} text="Back to all competencies"  className="assessment-back-button"/>

      <div className={`gw-competency-area-view-content gw-competency-area-page ${getPageTransitionClass(isTransitioning, transitionDirection)}`}>
        <CompetencyAssessmentTitleCard
          name={currentCompetency.name}
          description={currentCompetency.description}
          isFocus={currentCompetency.evaluation?.focus}
          evaluationId={currentCompetency.evaluation?.id}
        />
      </div>

      <div className={`gw-competency-assessment-content ${getPageTransitionClass(isTransitioning, transitionDirection)}`}>
        <CompetencyAssessmentContent
          competency={currentCompetency}
        />
      </div>

      <GrowthWheelPagination
        currentIndex={currentIndex}
        optionsList={competencyList}
        handleClickPrevious={handlePrevious}
        handleClickNext={handleNext}
        type="Competency"
      />
    </div>
  )
}

export default GrowthWheelCompetencyAssessment